import { render, staticRenderFns } from "./HomeBackButtonHandler.vue?vue&type=template&id=3f6a6a44&scoped=true"
import script from "./HomeBackButtonHandler.vue?vue&type=script&lang=js"
export * from "./HomeBackButtonHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a6a44",
  null
  
)

export default component.exports